var login = {
  translation: {
    common: {
      accept: 'Accepter',
      alreadyUser: 'Déjà utilisateur ?',
      and: 'et',
      backToLogin: 'Retour à la page de connexion',
      continueWith: 'Continuer avec {{provider}}',
      createAccount: 'Créer un compte',
      createYourAccount: 'Créez votre compte',
      emailOrUsername: "Email ou nom d'utilisateur",
      login: 'Se connecter',
      logIn: 'Se connecter',
      logInToBoards: 'Se connecter',
      newToBoards: 'Vous débutez avec les cartes Viki Teams?',
      pageNotFound_title: 'Page non trouvée',
      password: 'Mot de passe',
      privacyPolicy: 'Politique de confidentialité',
      register: 'Registre',
      registerWithGoogle: 'Inscrivez-vous sur Google',
      termsOfService: "Conditions d'utilisation",
      togglePasswordVisibility: 'Activer/désactiver la visibilité du mot de passe',
    },
  },
};

export { login as default };
